import { render, staticRenderFns } from "./OsConfirmDialog.vue?vue&type=template&id=1cc6d8b0&scoped=true"
import script from "./OsConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./OsConfirmDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6d8b0",
  null
  
)

export default component.exports